<span [innerHTML]="currency() | currencyIcon"></span>